import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

const ProfileMenuItem = (props) => {
    const getType = () => {
        if (props.to) {
            return 'reactLink';
        } else if (props.href) {
            return 'link';
        } else if (props.onClick) {
            return 'button';
        }
    };

    const getIconAndText = () => (
        <>
            <IconWrapper>
                <Icon name={props.iconName} color="primary" />
            </IconWrapper>
            <Text>{props.text}</Text>
        </>
    );

    const getBody = (rightText, labelText) => {
        if (rightText) {
            return (
                <>
                    <PanelRow>
                        <PanelRow alignStart>{getIconAndText()}</PanelRow>
                        <PanelRightBlock>
                            <Text color="secondary">{rightText}</Text>
                        </PanelRightBlock>
                    </PanelRow>
                </>
            );
        } else if (labelText) {
            return (
                <>
                    <PanelRow>
                        <PanelRow alignStart>{getIconAndText()}</PanelRow>
                        <PanelRightBlock>
                            <Badge variant="primary" caption={labelText} />
                        </PanelRightBlock>
                    </PanelRow>
                </>
            );
        } else {
            return getIconAndText();
        }
    };

    return (
        <Panel type={getType()} href={props.href} to={props.to} onClick={props.onClick} hasIcon negativeMargin isHoverable>
            {getBody(props.rightText, props.labelText)}
        </Panel>
    );
};

ProfileMenuItem.propTypes = {
    iconName: PropTypes.string.isRequired,
    text: PropTypes.node,
    rightText: PropTypes.node,
    labelText: PropTypes.node,
    href: PropTypes.string,
    to: PropTypes.string,
    onClick: PropTypes.func,
};

export default ProfileMenuItem;
